import { AchievementLatest } from './achievement-latest';
import { AchievementType, assertAchievementType } from './achievement-type';
import { AchievementDto } from './achievement.dto';

export class Achievement implements AchievementLatest {
    id: string;
    name: string;
    description: string;
    progress: number;
    type: AchievementType;

    constructor(data: AchievementDto) {
        this.id = data.id;
        this.name = data.name;
        this.description = data.description;
        this.progress = data.progress ? Math.max(0, Math.min(100, data.progress)) : 0; // Ensure progress is between 0 and 100
        assertAchievementType(data.type);
        this.type = data.type;
    }

    static initial(): Achievement {
        return new Achievement({
            id: '',
            name: '',
            description: '',
            progress: 0,
            type: 'diligent-student', // Default type, can be changed later
        });
    }
}
